import * as angular from 'angular';
import { FormatCellularStatusFilter } from './FormatCellularStatus';
import { FormatMacAddressFilter } from './FormatMacAddress';
import { FormatNullValueFilter } from './FormatNullValue';
import { FormatNullValueAsFilter } from './FormatNullValueAs';
import { StrippedMacFilter } from './FormatStrippedMac';

const filterModule = angular.module('app.areas.common.filters', []);

filterModule
    .filter('nullVal', [FormatNullValueFilter.Factory])
    .filter('nullValAs', [FormatNullValueAsFilter.Factory])
    .filter(FormatMacAddressFilter.$name, [FormatMacAddressFilter.Factory])
    .filter('cellularDeviceStatus', FormatCellularStatusFilter.Factory())
    .filter('strippedMacFilter', [StrippedMacFilter.Factory]);

export default filterModule.name;
